import { UseMutationResult } from '@tanstack/react-query'

import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { deleteSystem } from '../api/system-details.api'

interface UseDeleteSystemParams {
  onSuccess?: (vars: DeleteSystemVariables) => void
  onError?: (vars: DeleteSystemVariables) => void
}

interface DeleteSystemVariables {
  installationId: number | string
  deviceLinkId: number | string | undefined
  payload: { reason: string }
}

type UseDeleteSystemReturnType = (data: UseDeleteSystemParams) => UseMutationResult<null, unknown, DeleteSystemVariables>

export const useDeleteSystem: UseDeleteSystemReturnType = ({ onError, onSuccess }) => {
  const authFetch = useAuthFetchWithResult()

  const mutationResult = usePortalMutation({
    mutationFn: (vars: DeleteSystemVariables) => deleteSystem(vars.installationId, vars.deviceLinkId, vars.payload, authFetch),
    onSuccess: (_, vars) => onSuccess?.(vars),
    onError: (_, vars) => onError?.(vars),
  })

  return mutationResult
}
